import React from "react";
import {Link} from "react-router-dom";

import styles from "./BulkUpdateOptionCard.module.css";
import {BulkUpdateDefinition} from "../bulkUpdateDefinitions";

export const BulkUpdateOptionCard: React.FC<{ definition: BulkUpdateDefinition }> = ({definition}) =>
    <Link to={`/bulk-update/${definition.key}`} className={styles.card}>
        <div className={styles.main}>
            <img className={styles.logo} src={definition.iconSrc} alt={""}/>
            <span className={styles.name}>{definition.title}</span>
            <span className={styles.description}>{definition.description}</span>
            <span className={styles.badge}>CSV file</span>
        </div>
    </Link>;
